exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-job-jsx": () => import("./../../../src/pages/job.jsx" /* webpackChunkName: "component---src-pages-job-jsx" */),
  "component---src-pages-new-jsx": () => import("./../../../src/pages/new.jsx" /* webpackChunkName: "component---src-pages-new-jsx" */),
  "component---src-pages-update-jsx": () => import("./../../../src/pages/update.jsx" /* webpackChunkName: "component---src-pages-update-jsx" */)
}

